export default __webpack_public_path__ + "0b49f524418369f5be08371c85a4e41f.png";